// noinspection TypeScriptExplicitMemberType

export class ConfigKeys{

  // DESARROLLO

  // tslint:disable-next-line:max-line-length
 /*  URL_SHARE_PROMO_FACEBOOK: string = 'https://www.facebook.com/sharer/sharer.php?u=https://promocionesbancoppel.info/bancoppelws/promos/share/';
  URL_SHARE_PROMO_TWITTER: string = 'https://twitter.com/share?url=https://promocionesbancoppel.info/bancoppelws/promos/share/';
  // URL_SHARE_PROMO_WHATSAPP: string = 'whatsapp://send?text=https://promocionesbancoppel.info/showPromo/';
  URL_SHARE_PROMO_WHATSAPP: string = 'https://wa.me/?text=https://promocionesbancoppel.info/showPromo/';*/
  // tslint:disable-next-line:jsdoc-format
   /**DESARROLLO */

 /* URL_APP_MAIN = "https://promocionesbancoppel.info/";
  API_URL_LOGIN: string = 'https://promocionesbancoppel.info/bancoppelws/login?';
 API_URL_GET_BANNERS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/bannersByCard?';
 API_URL_GET_PROMOS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promos';
 API_URL_GET_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCard?';   /// Usable
 API_URL_GET_PROMOS_BY_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByPage?';
 API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCardPage?';  ///Usable
 API_URL_GET_CARDS: string = 'https://promocionesbancoppel.info/bancoppelws/bccards';
 API_URL_GET_PROMO_BY_ID: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promoById?';
 API_URL_GET_BRANCHES_BY_CITY: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/branchesByCity?';
 API_URL_GET_APP_PARAMS: string = 'https://promocionesbancoppel.info/bancoppelws/params';

  API_URL_GET_BANNERS_HOME_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/bannershp';
  API_URL_GET_CATEGORIES: string = 'https://promocionesbancoppel.info/bancoppelws/categories';
  API_URL_GET_STATES: string = 'https://promocionesbancoppel.info/bancoppelws/states';
  API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCardPageFilter?';  ///Usable
  API_URL_GET_NEARBY_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/nearByPromosByCard?';  ///Usable
  API_URL_GET_RELATED_PROMOS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/related?';  ///Usable

  API_URL_RECORD_VISIT: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/recordVisit';  ///Usable
  API_URL_GET_CAMPAIGN: string = 'https://promocionesbancoppel.info/bancoppelws/campaigns/';  ///Usable
  API_URL_GET_PROMOS_BY_CAMP: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCampPage?';  ///Usable*/


// tslint:disable-next-line:jsdoc-format
/**PRODUCTION */



  // tslint:disable-next-line:max-line-length
 URL_SHARE_PROMO_FACEBOOK: string = 'https://www.facebook.com/sharer/sharer.php?u=https://promocionesbancoppel.com/bancoppelws/promos/share/';
 URL_SHARE_PROMO_TWITTER: string = 'https://twitter.com/share?url=https://promocionesbancoppel.com/bancoppelws/promos/share/';
  URL_SHARE_PROMO_WHATSAPP: string = 'https://wa.me/?text=https://promocionesbancoppel.com/showPromo/';

  // URL_APP_MAIN = "http://localhost:4200/";
  URL_APP_MAIN: string = 'https://promocionesbancoppel.com/';
 API_URL_LOGIN: string = 'https://promocionesbancoppel.com/bancoppelws/login';
 API_URL_GET_BANNERS: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/bannersByCard?';
 API_URL_GET_PROMOS: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promos';
 API_URL_GET_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promosByCard?';   /// Usable
 API_URL_GET_PROMOS_BY_PAGE: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promosByPage?';
 API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promosByCardPage?';  ///Usable
 API_URL_GET_CARDS: string = 'https://promocionesbancoppel.com/bancoppelws/bccards';
 API_URL_GET_PROMO_BY_ID: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promoById?';
 API_URL_GET_BRANCHES_BY_CITY: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/branchesByCity?';
 API_URL_GET_APP_PARAMS: string = 'https://promocionesbancoppel.com/bancoppelws/params';


   API_URL_GET_BANNERS_HOME_PAGE: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/bannershp';
   API_URL_GET_CATEGORIES: string = 'https://promocionesbancoppel.com/bancoppelws/categories';
   API_URL_GET_STATES: string = 'https://promocionesbancoppel.com/bancoppelws/states';
   API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promosByCardPageFilter?';  ///Usable
   API_URL_GET_NEARBY_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/nearByPromosByCard?';  ///Usable
   API_URL_GET_RELATED_PROMOS: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/related?';  ///Usable

   API_URL_RECORD_VISIT: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/recordVisit';  ///Usable
   API_URL_GET_CAMPAIGN: string = 'https://promocionesbancoppel.com/bancoppelws/campaigns/';  ///Usable
   API_URL_GET_PROMOS_BY_CAMP: string = 'https://promocionesbancoppel.com/bancoppelws/bcpromos/promosByCampPage?';  ///Usable

 /*PRODUCCION-UAT */

  // tslint:disable-next-line:max-line-length
 /* URL_SHARE_PROMO_FACEBOOK: string = 'https://www.facebook.com/sharer/sharer.php?u=https://promocionesbancoppel.com/bancoppelwsuat/promos/share/';
  URL_SHARE_PROMO_TWITTER: string = 'https://twitter.com/share?url=https://promocionesbancoppel.com/bancoppelwsuat/promos/share/';
  URL_SHARE_PROMO_WHATSAPP: string = 'https://wa.me/?text=https://promocionesbancoppel.com/showPromo/';


 URL_APP_MAIN = "https://revisionbcoppel.maxvalue.com.mx/";
 API_URL_LOGIN: string = 'https://promocionesbancoppel.com/bancoppelwsuat/login?';
 API_URL_GET_BANNERS: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/bannersByCard?';
 API_URL_GET_PROMOS: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promos';
 API_URL_GET_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promosByCard?';   /// Usable
 API_URL_GET_PROMOS_BY_PAGE: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promosByPage?';
 API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promosByCardPage?';  ///Usable
 API_URL_GET_CARDS: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bccards';
 API_URL_GET_PROMO_BY_ID: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promoById?';
 API_URL_GET_BRANCHES_BY_CITY: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/branchesByCity?';
 API_URL_GET_APP_PARAMS: string = 'https://promocionesbancoppel.com/bancoppelwsuat/params';


API_URL_GET_BANNERS_HOME_PAGE: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/bannershp';
  API_URL_GET_CATEGORIES: string = 'https://promocionesbancoppel.com/bancoppelwsuat/categories';
  API_URL_GET_STATES: string = 'https://promocionesbancoppel.com/bancoppelwsuat/states';
  API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promosByCardPageFilter?';  ///Usable
  API_URL_GET_NEARBY_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/nearByPromosByCard?';  ///Usable
  API_URL_GET_RELATED_PROMOS: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/related?';  ///Usable

  API_URL_RECORD_VISIT: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/recordVisit';  ///Usable
  API_URL_GET_CAMPAIGN: string = 'https://promocionesbancoppel.com/bancoppelwsuat/campaigns/';  ///Usable
  API_URL_GET_PROMOS_BY_CAMP: string = 'https://promocionesbancoppel.com/bancoppelwsuat/bcpromos/promosByCampPage?';  ///Usable*/


   /* URL_APP_MAIN = "http://devsws.maxvalue.com.mx/";
   API_URL_LOGIN: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/login?';
  API_URL_GET_BANNERS: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/promosByCard?';
  API_URL_GET_PROMOS_BY_PAGE: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/promosByCardPage?';
  API_URL_GET_CARDS: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/bcpromos/branchesByCity?';
   API_URL_GET_APP_PARAMS: string = 'http://devsws.maxvalue.com.mx:8080/bancoppelws/params';
 */


  /* URL_APP_MAIN = "http://localhost:4200/";

   API_URL_LOGIN: string = 'http://192.168.100.70:8080/bancoppelws/login';
  API_URL_GET_BANNERS: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promosByCard?';   /// Usable
  API_URL_GET_PROMOS_BY_PAGE: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promosByCardPage?';  ///Usable
  API_URL_GET_CARDS: string = 'http://192.168.100.70:8080/bancoppelws/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'http://192.168.100.70:8080/bancoppelws/params';

  API_URL_GET_BANNERS_HOME_PAGE: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/bannershp';
  API_URL_GET_CATEGORIES: string = 'http://192.168.100.70:8080/bancoppelws/categories';
  API_URL_GET_STATES: string = 'http://192.168.100.70:8080/bancoppelws/states';
  API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promosByCardPageFilter?';  ///Usable
  API_URL_GET_NEARBY_PROMOS_BY_CARD: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/nearByPromosByCard?';  ///Usable
  API_URL_GET_RELATED_PROMOS: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/related?';  ///Usable

  API_URL_RECORD_VISIT: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/recordVisit';  ///Usable
  API_URL_GET_CAMPAIGN: string = 'http://192.168.100.70:8080/bancoppelws/campaigns/';  ///Usable
  API_URL_GET_PROMOS_BY_CAMP: string = 'http://192.168.100.70:8080/bancoppelws/bcpromos/promosByCampPage?';  ///Usable*/

  //------DEV

  /*URL_APP_MAIN = "https://promocionesbancoppel.info/";

  API_URL_LOGIN: string = 'https://promocionesbancoppel.info/bancoppelws/login?';
  API_URL_GET_BANNERS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCard?';   /// Usable
  API_URL_GET_PROMOS_BY_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCardPage?';  ///Usable
  API_URL_GET_CARDS: string = 'https://promocionesbancoppel.info/bancoppelws/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'https://promocionesbancoppel.info/bancoppelws/params';

  API_URL_GET_BANNERS_HOME_PAGE: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/bannershp';
  API_URL_GET_CATEGORIES: string = 'https://promocionesbancoppel.info/bancoppelws/categories';
  API_URL_GET_STATES: string = 'https://promocionesbancoppel.info/bancoppelws/states';
  API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCardPageFilter?';  ///Usable
  API_URL_GET_NEARBY_PROMOS_BY_CARD: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/nearByPromosByCard?';  ///Usable
  API_URL_GET_RELATED_PROMOS: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/related?';  ///Usable

  API_URL_RECORD_VISIT: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/recordVisit';  ///Usable
  API_URL_GET_CAMPAIGN: string = 'https://promocionesbancoppel.info/bancoppelws/campaigns/';  ///Usable
  API_URL_GET_PROMOS_BY_CAMP: string = 'https://promocionesbancoppel.info/bancoppelws/bcpromos/promosByCampPage?';  ///Usable*/

  /*LOCAL-UAT */
  /*  URL_APP_MAIN = "http://192.168.0.26:4200/";
   API_URL_LOGIN: string = 'http://192.168.0.26:8080/bancoppelwsuat/login?';
  API_URL_GET_BANNERS: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/promosByCard?';   /// Usable
  API_URL_GET_PROMOS_BY_PAGE: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/promosByCardPage?';  ///Usable
  API_URL_GET_CARDS: string = 'http://192.168.0.26:8080/bancoppelwsuat/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'http://192.168.0.26:8080/bancoppelwsuat/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'http://192.168.0.26:8080/bancoppelwsuat/params';
 */

 /* URL_APP_MAIN = "http://192.168.0.26:4200/";
   API_URL_LOGIN: string = 'http://192.168.1.142:8080/bancoppelws/login?';
  API_URL_GET_BANNERS: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/banners';
  API_URL_GET_PROMOS: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/promosByCard?';
  API_URL_GET_PROMOS_BY_PAGE: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/promosByCardPage?';
  API_URL_GET_CARDS: string = 'http://192.168.1.142:8080/bancoppelws/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'http://192.168.1.142:8080/bancoppelws/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'http://192.168.1.142:8080/bancoppelws/params';
 */
/** DESARROLLO */

  /* URL_APP_MAIN = "https://www.promocionesbancoppel.info/";
  API_URL_LOGIN: string = 'https://uat.maxvalue.com.mx/bancoppelws/login?';
  API_URL_GET_BANNERS: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/promosByCard?';   /// Usable
  API_URL_GET_PROMOS_BY_PAGE: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/promosByCardPage?';  ///Usable
  API_URL_GET_CARDS: string = 'https://uat.maxvalue.com.mx/bancoppelws/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'https://uat.maxvalue.com.mx/bancoppelws/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'https://uat.maxvalue.com.mx/bancoppelws/params'; */



  /** DESARROLLO - UAT*/

 /*  URL_APP_MAIN = "https://uat.promocionesbancoppel.info/";
  API_URL_LOGIN: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/login?';
  API_URL_GET_BANNERS: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/bannersByCard?';
  API_URL_GET_PROMOS: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/promos';
  API_URL_GET_PROMOS_BY_CARD: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/promosByCard?';   /// Usable
  API_URL_GET_PROMOS_BY_PAGE: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/promosByPage?';
  API_URL_GET_PROMOS_BY_CARD_PAGE: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/promosByCardPage?';  ///Usable
  API_URL_GET_CARDS: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bccards';
  API_URL_GET_PROMO_BY_ID: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/promoById?';
  API_URL_GET_BRANCHES_BY_CITY: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/bcpromos/branchesByCity?';
  API_URL_GET_APP_PARAMS: string = 'https://uat.maxvalue.com.mx/bancoppelwsuat/params';
 */

  API_USER: string = 'mbanales';
  API_PWD: string = 'Mace9518_';

  ICON_ACTIVE_PAGE = "assets/img/Paginador_On.png";
  ICON_INACTIVE_PAGE = "assets/img/Paginador_Off.png";

  DEFAULT_PAGE_SIZE: number = 12;
  DEFAULT_PAGE_SIZE_ALL: number = 1000;

  PARAM_BCOPPEL_URL = "BCOPPEL_URL";
  PARAM_IOS_APP_URL = "IOS_APP_URL";
  PARAM_ANDROID_APP_URL = "ANDROID_APP_URL";
  PARAM_FACEBOOK_URL = "FACEBOOK_URL";
  PARAM_YOUTUBE_URL = "YOUTUBE_URL";
  PARAM_TC_CAMPANIAS_URL = "TC_CAMP_URL";
  PARAM_AVISO_PRIV_URL = "AVISO_PRIV_URL";
  PARAM_SEGURIDAD_URL = "SEGURIDAD_URL";
  PARAM_IPAB_URL = "IPAB_URL";

  PARAM_REQ_CARD_URL1 = "REQUEST_CARD_URL_1";
  PARAM_REQ_CARD_URL2 = "REQUEST_CARD_URL_2";
  PARAM_REQ_CARD_URL3 = "REQUEST_CARD_URL_3";
  PARAM_REQ_CARD_URL4 = "REQUEST_CARD_URL_4";

  PROMO_TYPE_PROMO = 1;
  PROMO_TYPE_BANNER = 2;
  PROMO_TYPE_INFORMATIVA = 3;

  USER_ID_KEY = "p2@329843998232aQwmkFtr";

}
